import { axiosWithAuth } from "@/lib/AxiosClient";
import { GeometeryType } from "@/lib/models"

export interface ICode {
  id: string
  name: string
  value: string
  type: string
}

export class Code implements ICode {
  constructor(id: string, name: string, value: string, type: string, isDefault: boolean) {
    this.id = id
    this.name = name
    this.value = value
    this.type = type
    this.isDefault = isDefault
  }

  id: string
  name: string
  value: string
  type: string
  isDefault: boolean
}

export class FeatureCode extends Code {
  constructor(
    id: string,
    name: string,
    value: string,
    type: string,
    subType: string,
    isDefault: boolean,
    types: Array<IFeatureType>) {
      super(id, name, value, type, isDefault)
      this.types = types
      this.subType = subType
  }

  types: Array<IFeatureType>
  subType: string
}

export interface IPolygonStyle {
  strokeColour: string
  strokeOpacity: number
  strokeWeight: number
  fillColour: string
  fillOpacity: number
}

export interface IPolylineStyle {
  strokeColour: string,
  strokeOpacity: number
  strokeWeight: number
}

export interface IFeatureType{
  type: GeometeryType
}

export interface IPolygonFeatureType extends IFeatureType {
  style: IPolygonStyle
}

export interface IPolylineFeatureType extends IFeatureType {
  style: IPolylineStyle
}

export interface IPointFeatureType extends IFeatureType {
  style: IPolylineStyle
}

export interface IAnnulusFeatureType extends IFeatureType {
  style: IPolygonStyle
}

export class CodeService {
  private static readonly BASE_PATH = "/api/codes"
  private static instance = axiosWithAuth;

  static getCodes2(): Promise<Code[]> {
    return this.instance
      .get<Code[]>(this.BASE_PATH)
      .then(codes => {
        const returnCodes: Code[] = []
        codes.data.forEach(x => {
          if (x.type === "Feature") {
            returnCodes.push(mapFeatureCode(x as FeatureCode))
          } else {
            returnCodes.push(x)
          }
        })
        return returnCodes;
      })
  }

  static async getCodes(): Promise<ICode[]> {
    const response = await this.instance.get<ICode[]>(this.BASE_PATH)
    return response.data
  }
}

const mapFeatureCode = (featureCode: FeatureCode) : FeatureCode => {
  return new FeatureCode(featureCode.id, featureCode.name, featureCode.value, featureCode.type, featureCode.subType, featureCode.isDefault, featureCode.types.map(c => mapFeatureType(c)))
}

const mapFeatureType = (featureType: IFeatureType): IFeatureType => {
  switch(featureType.type) {
    case GeometeryType.Line: 
      return featureType as IPolylineFeatureType
    case GeometeryType.Point:
      return featureType as IPointFeatureType
    case GeometeryType.Polygon:
      return featureType as IPolygonFeatureType
    case GeometeryType.Annulus:
      return featureType as IAnnulusFeatureType          
  }
}